import { createAction } from 'redux-actions';

export const moduleName = 'breakpoint';

export const BREAKPOINT_SWITCH = `${moduleName}/BREAKPOINT_SWITCH`;

export const switchBreakpoint = createAction(BREAKPOINT_SWITCH, breakpoint => breakpoint);
